import { createFileRoute } from '@tanstack/react-router'

import PagePocRecipeRun from '@/pages/PagePocRecipeRun'

export const Route = createFileRoute('/poc/recipe-generator/$runId/')({
  // Each run owns its drafts; remount instead of carrying edits between runs.
  remountDeps: ({ params }) => params,
  component: PagePocRecipeRun
})
